import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Menu, X, Moon, Sun, Heart } from 'lucide-react';

const Header = ({ theme, setTheme }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const toggleTheme = () => setTheme(theme === 'light' ? 'dark' : 'light');

  // Close menu when route changes
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  const handleNavigationClick = (path) => {
    setIsMenuOpen(false);
    navigate(path);
  };
  return (
    <header className="bg-white dark:bg-gray-800 shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2">
          <img
            src="/favicon-512.png"
            alt="AI Transparency App Logo"
            className="w-10 h-10 object-contain rounded-full"
          />
          <span className="text-xl md:text-2xl font-bold text-gray-800 dark:text-gray-100">
            AI Transparency
          </span>
        </Link>
        <nav className="hidden md:flex items-center space-x-4">
          <Link to="/" className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400">Home</Link>
          <Link to="/privacy" className="text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400">Privacy</Link>
          <a 
            href="https://donate.stripe.com/test_dRmaEQ4Sj1oc0no3OO18c00" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-600 dark:text-gray-300 hover:text-pink-600 dark:hover:text-pink-400 flex items-center gap-1"
          >
            <Heart className="w-4 h-4" />
            Donate
          </a>
          <button onClick={toggleTheme} className="p-2 rounded-full">
            {theme === 'light' ? <Moon /> : <Sun className="text-yellow-500" />}
          </button>
          <Link to="/report" className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 shadow">Report AI Use</Link>
        </nav>
        <div className="md:hidden flex items-center space-x-2">
          <button onClick={toggleTheme} className="p-2 rounded-full">
            {theme === 'light' ? <Moon /> : <Sun />}
          </button>
          <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {isMenuOpen && (
        <div className="md:hidden bg-white dark:bg-gray-800 py-4">
          <nav className="flex flex-col items-center space-y-4">
            <button onClick={() => handleNavigationClick('/')} className="text-lg cursor-pointer">Home</button>
            <button onClick={() => handleNavigationClick('/privacy')} className="text-lg cursor-pointer">Privacy</button>
            <a 
              href="https://donate.stripe.com/test_dRmaEQ4Sj1oc0no3OO18c00" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-lg cursor-pointer flex items-center gap-2 text-pink-600 dark:text-pink-400"
            >
              <Heart className="w-5 h-5" />
              Donate
            </a>
            <button onClick={() => handleNavigationClick('/report')} className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow-lg text-lg cursor-pointer">Report AI Use</button>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;